import {
  createSelector,
} from 'reselect';

import {
  getResourceMappedList,
} from './resources';

import {
  sortByPosition,
  alphSortSearchOptions,
} from './utils';

export const getProgamWeeks = (programId: number, resourceType: string) => createSelector(
  [
    getResourceMappedList('programWeeks', `program_${programId}`),
    getResourceMappedList('programWorkouts', `program_${programId}`),
    getResourceMappedList(
      resourceType === 'programTemplates'
        ? 'workoutTemplates'
        : 'personalWorkouts',
      `program_${programId}`,
    ),
  ],
  (
    weeks,
    programWorkouts,
    workouts,
  ) => {
    const getWorkouts = (weekId: number | null) => programWorkouts
      .filter(w => w.week_id === weekId)
      .sort((a, b) => (a.position > b.position ? 1 : -1))
      .map(w => ({
        ...w,
        name: workouts.find(t => t.id === w.workout_id)?.name,
      }));

    const initial = [];
    const noWeek = getWorkouts(null);

    if (noWeek.length) {
      initial.push({
        id: -1,
        name: 'Workouts',
        workouts: noWeek,
      });
    }

    return weeks
      .sort(sortByPosition)
      .reduce((acc, week) => [
        ...acc,
        {
          ...week,
          workouts: getWorkouts(week.id),
        },
      ], initial);
  },
);

export const getProgamWorkoutOptions = (personId) => createSelector(
  [
    getResourceMappedList('workoutTemplates', 'library'),
    getResourceMappedList(
      'personalWorkouts',
      personId === 'me' ? personId : `client_${personId}`,
    ),
  ],
  (
    workoutTemplates,
    personalWorkouts,
  ) => (personId !== 'me'
    ? [
      ...workoutTemplates
        .map(
          ({ id, name }) => ({
            label: name,
            value: String(id),
          }),
        )
        .sort(alphSortSearchOptions),
      {
        label: 'Personal Workouts',
        options: personalWorkouts
          .filter(w => !w.is_for_single_exercise)
          .map(
            ({ id, name }) => ({
              label: name,
              value: String(id),
              isPersonalWorkout: true,
            }),
          )
          .sort(alphSortSearchOptions),
      },
    ]
    : workoutTemplates
      .map(
        ({ id, name }) => ({
          label: name,
          value: String(id),
        }),
      )
      .sort(alphSortSearchOptions)),
);
